import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @file Axis 单一数字坐标轴
 */
import { Emitter } from '@tencent/glue-util-emitter';
export var Axis = /*#__PURE__*/function (_Emitter) {
  _inherits(Axis, _Emitter);

  var _super = _createSuper(Axis);

  function Axis(region, type) {
    var _this;

    _classCallCheck(this, Axis);

    _this = _super.call(this); // 步长

    _this.step = 1; // 区间下限

    _this.min = 0; // 区间上线

    _this.max = 0; // 是否严格模式

    _this.strict = false;
    _this.type = type;
    _this.region = region;
    return _this;
  }
  /**
   * 获取值的精度
   * @param value 值
   */


  _createClass(Axis, [{
    key: "getAxisType",
    value: // 坐标轴的类型
    function getAxisType() {
      return this.type;
    } // 获取所属区域

  }, {
    key: "getRegion",
    value: function getRegion() {
      return this.region;
    } // 获取坐标轴长度

  }, {
    key: "getAxisLength",
    value: function getAxisLength() {
      return this.region.getAxisLength(this.type);
    } // 根据数值，获取数值对应的Offset

  }, {
    key: "getValueOffset",
    value: function getValueOffset(value) {
      return Math.floor((value - this.min) / (this.max - this.min) * this.getAxisLength());
    } // 获取实例属性，方便展示和调试

  }, {
    key: "getAxisConfig",
    value: function getAxisConfig() {
      return {
        strict: this.strict,
        max: this.max,
        min: this.min,
        step: this.step,
        precision: this.getMaxPrecision()
      };
    } // 更新实例属性

  }, {
    key: "updateAxisConfig",
    value: function updateAxisConfig(config) {
      var _config$strict = config.strict,
          strict = _config$strict === void 0 ? false : _config$strict,
          _config$step = config.step,
          step = _config$step === void 0 ? 1 : _config$step,
          precision = config.precision,
          min = config.min,
          max = config.max;
      this.step = step;
      this.precision = precision;
      this.strict = strict;

      if (config.strict) {
        if (min == null || max == null) {
          throw new Error('props `min` and `max` are required in strict mode');
        }

        this.min = min;
        this.max = max;

        if (!this.isValidValue(max)) {
          throw new Error("max is invalid:  max = ".concat(max, " doesn't match formula `min + step * n, n is integer`"));
        }
      } else {
        this.min = min == null ? Number.MIN_SAFE_INTEGER : min;
        this.max = max == null ? Number.MAX_SAFE_INTEGER : max;
      }

      this.repaint();
    } // 刷新坐标轴组件

  }, {
    key: "repaint",
    value: function repaint() {
      this.emit('repaint');
    } // 格式化数值字符串

  }, {
    key: "formatPrecisionValue",
    value: function formatPrecisionValue(val, precisionValue) {
      var precision = this.getMaxPrecision(precisionValue);

      if (!isNaN(precision)) {
        return val.toFixed(precision);
      }

      return String(val);
    }
  }, {
    key: "getOffsetPrecisionValue",
    value: function getOffsetPrecisionValue(offset) {
      var max = this.max,
          min = this.min;

      if (this.getAxisLength() === 0) {
        return this.formatPrecisionValue(this.getValidValue(0));
      }

      return this.formatPrecisionValue(this.getValidValue(offset / this.getAxisLength() * (max - min) + min));
    } // 判断当前字符串值是否合法

  }, {
    key: "isValidPrecisionValue",
    value: function isValidPrecisionValue(value) {
      return this.isValidValue(+value);
    } // 判断value是否符合当前值

  }, {
    key: "isValidValue",
    value: function isValidValue(value) {
      var strict = this.strict,
          min = this.min,
          max = this.max,
          step = this.step;

      if (isNaN(value)) {
        return false;
      }

      if (min != null && value < min || max != null && value > max) {
        return false;
      }

      if (strict) {
        // 合法值应该满足  min + step * n(n是整数)
        return (value - min) % step === 0;
      }

      return true;
    } // 获取最大精度

  }, {
    key: "getMaxPrecision",
    value: function getMaxPrecision(value) {
      if (this.precision != null) {
        return this.precision;
      }

      var minPrecision = Axis.getPrecision(this.min);
      var maxPrecision = Axis.getPrecision(this.max);
      var stepPrecision = Axis.getPrecision(this.step);
      var currentValuePrecision = value == null ? 0 : Axis.getPrecision(value);
      return Math.max(currentValuePrecision, stepPrecision, minPrecision, maxPrecision);
    }
  }, {
    key: "isValueSelected",
    value: function isValueSelected(value) {
      return this.region.isAxisSelected(this.type, value);
    }
  }, {
    key: "isAxisSelected",
    value: function isAxisSelected(value) {
      return this.region.isAxisSelected(this.type, value);
    } // 获取一个值的区间合法值

  }, {
    key: "getValidValue",
    value: function getValidValue(value) {
      var val = value;

      if (isNaN(val)) {
        throw new Error("".concat(val, " is not a valid number"));
      } // 如果有strict，就寻找一个合适的值


      if (this.strict) {
        var count = Math.round((val - this.min) / this.step);
        val = count * this.step + this.min;
      }

      if (this.min != null && val < this.min) {
        val = this.min;
      }

      if (this.max != null && val > this.max) {
        val = this.max;
      }

      return val;
    }
  }, {
    key: "stepPrecisionValue",
    value: function stepPrecisionValue(value) {
      var stepCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      return this.formatPrecisionValue(this.getValidValue(Number(value) + stepCount * this.step), value);
    }
  }], [{
    key: "getPrecision",
    value: function getPrecision(value) {
      var valueString = value.toString();

      if (valueString.indexOf('e-') >= 0) {
        return parseInt(valueString.slice(valueString.indexOf('e-') + 2), 10);
      }

      var precision = 0;

      if (valueString.indexOf('.') >= 0) {
        precision = valueString.length - valueString.indexOf('.') - 1;
      }

      return precision;
    }
  }]);

  return Axis;
}(Emitter);